import * as HotspotTargetType from "utils/HotspotTargetType";
import { createSelector } from "reselect";
import { getHotspotCallToAction } from "selectors/hotspot/makeGetHotspotCallToAction";
import getIsSafari from "selectors/device/getIsSafari";
import { makeGetVideoEntity } from "selectors/makeGetVideoEntity";
import makeGetChapterHotspots from "selectors/hotspot/makeGetChapterHotspots";
import { getOptionalChapterEntity } from "selectors/chapter/makeGetChapterEntity";
import * as ChapterType from "utils/ChapterType";
import getPlaybackState from "selectors/chapter/getPlaybackState";
import defaults from "lodash/defaults";
import getAllChapters from "selectors/hotspot/getAllChapters";
import makeGetPosterUrl from "selectors/video/makeGetPosterUrl";

const getChapterHotspots = (state, props) => {
  const getChapterHotspotsData = makeGetChapterHotspots();
  return props.chapterId ? getChapterHotspotsData(state, props) : [];
};

const getStorySlug = (state) => state.route.params.storySlug;

const getDesignMode = (state) => state.playerOptions.designMode;

export default function makeGetThreeConfig() {
  const getVideoEntity = makeGetVideoEntity();
  const getPosterUrl = makeGetPosterUrl();
  return createSelector(
    getAllChapters,
    getOptionalChapterEntity,
    getChapterHotspots,
    getDesignMode,
    getIsSafari,
    getPlaybackState,
    getPosterUrl,
    getStorySlug,
    getVideoEntity,
    (
      allChapters,
      chapterEntity,
      chapterHotspots,
      designMode,
      isSafari,
      playbackState,
      posterUrl,
      storySlug,
      videoEntity,
    ) => {
      const currentOrientation = defaults(
        {},
        playbackState.orientation,
        { lon: videoEntity.initialRotation },
        { lon: 0, lat: 0 },
      );
      let playingLoopVideo = false;
      if (chapterEntity && chapterEntity.type === ChapterType.PATHFINDER) {
        if (!chapterEntity.introductionVideo) {
          playingLoopVideo = true;
        } else if (playbackState) {
          const duration = chapterEntity.introductionVideo
            ? chapterEntity.introductionVideo.duration
            : 0;
          playingLoopVideo = playbackState.time >= duration;
        }
      }
      return {
        designMode,
        initialRotation: currentOrientation,
        isSafari,
        videoPosterUrl: posterUrl,
        hotspots: chapterHotspots
          .filter((hotspot) => hotspot.is360)
          .map((hotspot) => {
            const linkless = hotspot.target.type === HotspotTargetType.NONE;
            const targetType = hotspot.target.type;
            const targetChapterId = hotspot.target.chapterId;
            const targetUrl = hotspot.target.target;
            return {
              ...hotspot,
              callToAction: getHotspotCallToAction(
                allChapters,
                hotspot,
              ).toUpperCase(),
              hotspotId: hotspot.localId,
              left: (hotspot.left / 100) * 360, // convert percentage to degrees
              linkless,
              playingLoopVideo,
              showInLoopVideo: chapterEntity.type === ChapterType.PATHFINDER,
              storySlug,
              targetChapterId,
              targetType,
              targetUrl,
              top: (hotspot.top / 100) * 180, // convert percentage to degrees
            };
          }),
      };
    },
  );
}
